import React from 'react';
import { Box, Tab, Tabs, Grid } from '@mui/material';
import getTabStyle from './styles/style';

const TabBar = ({
  tabList,
  selectedCurrentTab,
  color,
  renderLabelCondition,
  actionButton,
  showActionButton,
  transparentBackground,
  isMobile,
  scrollButtons,
  hideTabs,
  hideOption,
  extraStyling,
  size,
}: {
  tabList;
  selectedCurrentTab;
  color;
  renderLabelCondition;
  actionButton;
  showActionButton?;
  transparentBackground?: boolean;
  isMobile?: boolean;
  scrollButtons?: boolean;
  hideTabs?: boolean;
  hideOption?: string;
  extraStyling?: any;
  size?: string;
}) => {
  const renderLabel = renderLabelCondition();
  let styles = getTabStyle(color, transparentBackground ? transparentBackground : false);

  return (
    <Box
      sx={{
        ...styles.root,
        ...(extraStyling ? extraStyling : {}),
        padding: '0 !important',
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent={hideTabs ? 'flex-end' : isMobile ? 'center' : 'space-between'}
        alignItems="center"
        item
        xs={12}
      >
        {!hideTabs && (
          <Tabs
            value={selectedCurrentTab}
            variant="scrollable"
            scrollButtons={scrollButtons ? true : false}
            TabIndicatorProps={{
              style: { height: '2px', bottom: 0 },
            }}
            sx={{
              minHeight: 0,
              paddingBottom: 0,
              marginBottom: 0,
              height: 'auto',
              '& .MuiTabs-scroller': {
                minHeight: 0,
                height: 'auto',
              },
              '& .MuiTabs-flexContainer': {
                minHeight: 0,
                height: 'auto',
              },
            }}
          >
            {tabList
              .filter(currentTab => currentTab.value !== (hideOption ? hideOption : ''))
              .map((currentTab, index) => {
                return (
                  <Tab
                    key={index + '-tab-bar'}
                    className={'tab-bar-tab'}
                    icon={
                      isMobile ? (
                        undefined
                      ) : currentTab.beta && selectedCurrentTab === currentTab.value ? (
                        <Box display="flex" alignItems="center">
                          {currentTab.icon}
                        </Box>
                      ) : (
                        currentTab.icon
                      )
                    }
                    label={
                      currentTab.badge ? (
                        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                          <span>
                            {renderLabel ? (isMobile ? currentTab.mobileLabel : currentTab.label) : ''}
                          </span>
                          <Box
                            component="span"
                            sx={{
                              fontSize: 10,
                              fontWeight: 600,
                              bgcolor: 'primary.main',
                              color: 'primary.contrastText',
                              px: 0.75,
                              py: 0.25,
                              borderRadius: 1,
                              lineHeight: 1.2,
                            }}
                          >
                            {currentTab.badge}
                          </Box>
                        </Box>
                      ) : (
                        <span>
                          {renderLabel ? (isMobile ? currentTab.mobileLabel : currentTab.label) : ''}
                        </span>
                      )
                    }
                    value={currentTab.value}
                    iconPosition="start"
                    sx={{
                      ...styles.tab,
                      // minHeight: '28px',
                      height: '28px',
                      minWidth: '56px',
                      padding: '0 6px',
                      // fontSize: theme.typography.body1?.fontSize ?? '14px',
                      '& .MuiSvgIcon-root': {
                        // fontSize: theme.typography.body1?.fontSize ?? '14px',
                      },
                      ...(size === 'small'
                        ? {
                            minHeight: '24px',
                            height: '24px',
                            minWidth: '48px',
                            padding: '0 4px',
                            // fontSize: theme.typography.body1?.fontSize ?? '14px',
                          }
                        : {}),
                    }}
                    onClick={currentTab.onclick}
                    wrapped
                  />
                );
              })}
          </Tabs>
        )}
        {showActionButton ? actionButton : <></>}
      </Grid>
    </Box>
  );
};

export default TabBar;
